<div class="ft2-spinner -large"></div>
<h1>{{ 'flipto.account.CreatingImage' | translate }}</h1>
